<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->

    <div class="b-center-container">
      <div class="b-container">

        <div class="b-center-main">
          <p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">Research Partners</span></p>
          <div style="margin-bottom:30px; margin-top: 40px; font-size: 20px; font-weight: bold"></div>
          <!-- 合作伙伴 -->
          <div class="b-imageset">
            <ul>
              <li v-for="item in imagesetList"
                  :key="item">
                <a :href="item.linkUrl" target="_blank">
                  <div class="b-item-link">
                    <img :src="item.img" :height="item.height"
                         alt="img">
                  </div>
                  <div class="b-item-name3">{{ item.name }}</div>
                </a>
              </li>
            </ul>
          </div>
<!--          <el-pagination background-->
<!--                         layout="prev, pager, next"-->
<!--                         :total="1000">-->
<!--          </el-pagination>-->

          <div class="b-imageset">
            <ul>
              <li v-for="item in imagesetList2"
                  :key="item">
                <a :href="item.linkUrl" target="_blank">
                  <div class="b-item-link">
                    <img :src="item.img" :height="item.height"
                         alt="img">
                  </div>
                  <div class="b-item-name3">{{ item.name }}</div>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/en/";
import Nav from "@/components/nav/en/";
import Breadcrumb from "@/components/breadcrumb/en/"
import Contact from "@/components/contact/en/";
export default {
  data () {
    return {
      imagesetList: [],
      imagesetList2: []
    };
  },
  mounted () {
    // 相册列表
    this.imagesetList = [
      {
        linkUrl: "https://www.scmc.com.cn",
        img: "https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/儿童医学中心.jpg",
        name: "Shanghai Children’s Medical Center"
      },
      {
        linkUrl: "https://www.ipmch.com.cn",
        img: "https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/国际和平妇幼保健院.png",
        name: "International Peace Maternity & Child Health Hospital of China Welfare Inst",
        height: 170
      },
      {
        linkUrl: "http://www.6thhosp.com",
        img: "https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/上海市第六人民医院.jpg",
        name: "Shanghai Sixth People's Hospital"
      },
      {
        linkUrl: "https://www.firsthospital.cn",
        img: "https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/上海市第一人民医院.png",
        name: "Shanghai General Hospital"
      },
      {
        linkUrl: "http://www.shchildren.com.cn",
        img: "https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/上海市儿童医院.png",
        name: "Children’s Hospital of Shanghai"
      },
      {
        linkUrl: "http://www.smhc.org.cn",
        img: "https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/上海市精神卫生中心.jpg",
        name: "Shanghai Mental Health Center",
        height: 170
      },
      {
        linkUrl: "http://www.kowloonhospital.com",
        img: "https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/苏州九龙医院.jpg",
        name: "Kowloon Hospital",
        height: 170
      },
      {
        linkUrl: "https://www.shtrhospital.com",
        img: "https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/同仁医院.jpg",
        name: "Tong Ren Hospital",
        height: 170
      },
      {
        linkUrl: "https://www.xinhuamed.com.cn",
        img: "https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/新华医院.jpeg",
        name: "Xinhua Hospital",
        height: 165
      },
      {
        linkUrl: "https://www.shxkyy.com",
        img: "https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/胸科医院.jpg",
        name: "Shanghai Chest Hospital",
        height: 170
      },
      {
        linkUrl: "http://www.9hospital.com.cn",
        img: "https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/九院logo.png",
        name: "Shanghai Ninth People's Hospital",
        height: 165
      },
      {
        linkUrl: "https://www.renji.com",
        img: "https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/仁济医院.jpg",
        name: "Renji Hospital"
      },
      {
        linkUrl: "http://www.rjh.com.cn",
        img: "https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/瑞金医院.png",
        name: "Ruijin Hospital"
      }
    ];

    this.imagesetList2 = [
      {
        linkUrl: "https://www.nifdc.org.cn",
        img: "https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/国家食品药品检定研究院logo.jpg",
        name: "National Institute for Food and Drug Control",
        height: 160
      },
      {
        linkUrl: "https://www.genomics.cn",
        img: "https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/华大基因logo.jpg",
        name: "BGI Genomics"
      },
      {
        linkUrl: "https://www.huawei.com/cn",
        img: "https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/华为logo.jpg",
        name: "HUAWEI"
      }
    ];
  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-breadcrumb": Breadcrumb,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
/* 相册列表 */
.b-imageset ul {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
  //height: -webkit-fill-available;
  li {
    width: 20%;
    float:left;
    margin: 0 0 15px 0;
    .b-item-link {
      margin: 0 8px;
      border: 1px solid #ddd;
      display: block;
      padding: 10px 10px;
      height: 200px;
      overflow: hidden;
    }
    .b-img {
      border: 3px solid rgb(204, 204, 204);
      border-radius: 100%;
      width: 120px;
      height: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      img {
        width: 70px;
      }
    }

    .b-item-name3 {
      text-align: center;
      color: rgb(102, 102, 102);
      font-size: 13px;
      /* font-weight: bold; */
      height: 50px;
      line-height: 25px;
      //overflow: hidden;
      text-overflow: ellipsis;
      //white-space: nowrap;
      word-break: break-all;
      margin: 10px 0;
      &:hover {
        color: #2ba8e2;
        text-decoration: none;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/imageset/en/index.vue